/** What a page shows in place of a tenant the caller may not see. */
export const TENANT_OUT_OF_SCOPE_MESSAGE = "You don't have access to this tenant";

/** What the caller can do about it. */
export const TENANT_OUT_OF_SCOPE_HINT =
  "Your account cannot view this tenant's services. Choose a tenant you manage from the tenant selector.";

/**
 * Whether a rejected request (an axios error) is the backend refusing a tenant outside
 * the caller's scope (CTX-866):
 * `403 { success: false, message, data: { requestedTenantId, allowedTenantId } }`.
 *
 * The backend used to answer such a request with the caller's own tenant instead, and
 * the dashboard painted and cached that under the requested key. A page that gets this
 * answer must neither paint it nor keep what it cached for the requested tenant.
 */
export function isTenantScopeForbidden(error: unknown): boolean {
  const response = (error as { response?: { status?: number; data?: { data?: unknown } } } | null)
    ?.response;
  if (response?.status !== 403) return false;
  const data = response.data?.data;
  return typeof data === "object" && data !== null && "requestedTenantId" in data;
}
